import { WifiOff } from 'lucide-react';
import { useIsOnline } from '@/store/useNetworkStore';

/**
 * Thin banner shown whenever the device loses connectivity.
 *
 * Because the web build is bundled inside the native app, the UI keeps
 * working offline (cached data renders fine); this banner just sets the
 * expectation that changes may not sync until the connection returns.
 */
export function OfflineBanner() {
  const isOnline = useIsOnline();
  if (isOnline) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 bg-warning-dark/90 px-4 py-1.5 text-xs font-medium text-white"
    >
      <WifiOff className="h-3.5 w-3.5" />
      <span>You&apos;re offline — changes will sync when you reconnect.</span>
    </div>
  );
}
